<svg xmlns="http://www.w3.org/2000/svg" width="30" height="25.41" viewBox="0 0 30 25.41">
  <g id="Group_73" data-name="Group 73" transform="translate(0.5 -0.59)">
    <g id="Group_2_Copy_5" data-name="Group 2 Copy 5" transform="translate(-0.5)">
      <g id="Group_2_Copy_2" data-name="Group 2 Copy 2">
        <g id="Rectangle_Copy_14" data-name="Rectangle Copy 14" transform="translate(0 4.589)" fill="#4562ff" stroke="#4562ff" stroke-width="0.867">
          <rect width="26" height="21.411" rx="1.73" stroke="none"/>
          <rect x="0.433" y="0.433" width="25.133" height="20.544" rx="1.297" fill="none"/>
        </g>
        <rect id="Rectangle" width="26" height="21.411" rx="1.733" transform="translate(4 0.59)" fill="#c7cfff"/>
        <rect id="Rectangle-2" data-name="Rectangle" width="12" height="9.588" rx="1" transform="translate(11 6.501)" fill="#4562ff"/>
      </g>
    </g>
  </g>
</svg>
